import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRequestForm } from "../../../../redux/slices/requestForm";
import { REQUEST_FIELDS } from "./request-fields";

/*
  Поля формы заявки для конкретного тура или услуги.

  value — объект. Пустой ({}) значит «как на всём сайте»: форма возьмёт
  общую настройку из раздела «Форма заявки». Как только галочку «настроить
  отдельно» включили, сюда кладётся полный набор полей и дальше этот тур
  живёт своей жизнью — общая настройка на него уже не влияет.
*/
export default function RequestFieldsInput({ value = {}, onChange }) {
  const dispatch = useDispatch();
  const global = useSelector((state) => state.requestForm.settings);

  useEffect(() => {
    dispatch(fetchRequestForm());
  }, [dispatch]);

  const custom = Boolean(value && Object.keys(value).length > 0);

  const toggleCustom = () => {
    // включаем — начинаем с копии общей настройки, выключаем — очищаем
    onChange(custom ? {} : { ...global });
  };

  const toggleField = (key) => onChange({ ...value, [key]: !value[key] });

  const noContact = custom && !value.phone && !value.email;

  return (
    <div className="w-full">
      <div className="block text-base font-medium text-neutral-700">
        Поля в форме заявки
      </div>

      <label className="mt-2 flex items-start gap-3 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={custom}
          onChange={toggleCustom}
          className="mt-1 h-4 w-4 rounded border-neutral-300 text-sky-600 focus:ring-sky-500"
        />
        <span>
          <span className="block text-sm font-medium text-neutral-900">
            Настроить отдельно для этой страницы
          </span>
          <span className="block text-sm text-neutral-500">
            {custom
              ? "Общая настройка сайта на эту страницу больше не влияет."
              : "Сейчас берутся общие настройки из раздела «Форма заявки»."}
          </span>
        </span>
      </label>

      {custom && (
        <div className="mt-3 ml-1 flex flex-col gap-1 border-l-2 border-neutral-200 pl-4">
          {REQUEST_FIELDS.map((field) => (
            <label
              key={field.key}
              className={`flex items-start gap-3 rounded-lg px-2 py-2 cursor-pointer hover:bg-neutral-50 ${
                field.indent ? "ml-5" : ""
              }`}
            >
              <input
                type="checkbox"
                checked={Boolean(value[field.key])}
                onChange={() => toggleField(field.key)}
                className="mt-0.5 h-4 w-4 rounded border-neutral-300 text-sky-600 focus:ring-sky-500"
              />
              <span className="min-w-0">
                <span className="block text-sm font-medium text-neutral-900">
                  {field.label}
                </span>
                {field.hint && (
                  <span className="block text-sm text-neutral-500">
                    {field.hint}
                  </span>
                )}
              </span>
            </label>
          ))}

          {noContact && (
            <p className="mt-1 text-sm text-red-600">
              Оставьте телефон или email — иначе клиент не сможет отправить
              заявку.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
